import { SVGProps } from 'react';
const SvgNote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8.586a1 1 0 0 0 .707-.293l5.414-5.414a1 1 0 0 0 .293-.707V5a1 1 0 0 0-1-1Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 13h-6a1 1 0 0 0-1 1v6"
    />
  </svg>
);
export default SvgNote;
